<div class="container-empty">
    <div class="icon">
        <ion-icon *ngIf="icon" name="{{icon}}"></ion-icon>
    </div>
    <br/>
    <span *ngIf="title"><strong>{{ title }}</strong></span>
    <span class="muted" *ngIf="description">{{description}}</span>
    <br/><br/>
    <ion-button *ngIf="buttonText" expand="block" (click)="goToUrl(route)">{{buttonText}}</ion-button>
</div>